export default __webpack_public_path__ + "static/media/gcp.df756fc7.svg";